/*
 * Copyright (c) 2025. Haodong JU
 */

import { hillo } from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

export const reservationLocalHost = 'https://cloud-v2.aaden.io'
const reservationPath = '/cloudUser/reservationUser'
export async function checkReservationStatus () {
  return (await hillo.jsonPost(reservationLocalHost + reservationPath + '/check', { deviceId: await getCurrentDeviceId() })).data
}

export async function getReservationUserCloudList () {
  return (await hillo.jsonPost(reservationLocalHost + reservationPath + '/getList', {})).data
}

export async function activeReservation (info) {
  info.slogan = ''
  info.autoConfirmReservation = false
  info.allowOnlyOneActiveReservation = false
  info.deviceId = await getCurrentDeviceId()
  info.maxReservationPerSlot = -1
  info.reservationTimeLimit = -1
  return (await hillo.jsonPost(reservationLocalHost + reservationPath + '/save', { ...info })).data
}

export async function updateReservationInfo (info) {
  return (await hillo.jsonPost(reservationLocalHost + reservationPath + '/save', { ...info })).data
}

export async function ifReserveOpen () {
  return (await checkReservationStatus()).basic
}
